import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[fiClickTriggerFor]',
    standalone: false,
})
export class FiClickTriggerForDirective {
    @Input() fiClickTriggerFor;

    @HostListener('click')
    onClick() {
        if (this.fiClickTriggerFor) {
            this.fiClickTriggerFor.click();
        }
    }
}
